<template>
    <layout-basic>
        <v-container>
            <section class="container-small banner-text">
                <v-row>
                    <v-col cols="12" md="12">
                        <div class="privay-content mb-50">
                            <p><span>The Information on this website is intended
                                    to be helpful and informative. However, neither Improve nor any of its
                                    employees, agents or sub-contractors make any warranty, express or implied, or
                                    assume any legal liability or responsibility for the accuracy or completeness
                                    of any information contained on this site or any web site referred to.</span></p>

                            <p><span>Those who access the site, or any site
                                    referred to should take appropriate steps to verify all such information. Improve
                                    Productions Ltd (trading as Improve) and its subsidiaries cannot be held
                                    responsible for the contents of any pages referred to by an external link. A
                                    reference on this site to any persons, products, web sites or services does not
                                    constitute or imply their endorsements, recommendation or favouring by&nbsp;Improve,
                                    its employees, agents or sub-contractors.</span></p>

                            <p><span>1. Definitions</span></p>

                            <p><span>1.1 “This Site” refers to all internet
                                    pages in the&nbsp;improve.online&nbsp;domain</span></p>

                            <p><span>1.2 “Improve” refers to any organisation
                                    involved in any part of the design, development, management, response-handling,
                                    marketing, promotion or other similar aspects of this Site</span></p>

                            <p><span>1.3 “User” refers to any person viewing or
                                    interacting with this Site, including “you”</span></p>

                            <p><span>1.4 “Content” refers to any text,
                                    photograph or other image presented on this Site to Users by
                                    either&nbsp;improve.online&nbsp;or
                                    Users.</span></p>

                            <p><span>2. Terms</span></p>

                            <p><span>2.1 By using this site, you agree to these
                                    terms of use. If you do not agree to these terms of use, disconnect from this
                                    site and do not use this site further.</span></p>

                            <p><span>3. Summary</span></p>

                            <p><span>3.1 Except where otherwise expressed, all
                                    opinions, advice, statements, offers, or other information content made
                                    available through this Site are those of third parties and not of&nbsp;Improve&nbsp;and
                                    should not be relied upon.&nbsp;Improve&nbsp;assumes no responsibility for any
                                    opinions, advice, statements, offers or other information provided on this
                                    Site.&nbsp;Improve&nbsp;does not guarantee the accuracy, completeness, or
                                    usefulness of any information on this Site and neither adopts nor endorses nor
                                    is responsible for the accuracy or reliability of any opinion, advice or
                                    statement made.&nbsp;Improve&nbsp;is not responsible for any Content that is
                                    illegal, offensive or otherwise actionable. Under no circumstances
                                    will&nbsp;Improve&nbsp;be
                                    responsible for any loss or damage resulting from anyone’s reliance on
                                    information or other Content posted on this Site or transmitted to Users</span></p>

                            <p><span>3.2&nbsp;Improve&nbsp;reserves the right,
                                    but has no obligation, to edit or remove any Content without question, reason
                                    or notice.</span></p>

                            <p><span>4. Site contents</span></p>

                            <p><span>4.1 The Content made available in this Site
                                    is provided “as is” without warranties of any kind, either express or implied,
                                    including but not limited to all implied warranties of satisfactory quality,
                                    fitness for a particular purpose, title, or non-infringement of any third party
                                    rights including, without limitation, intellectual property
                                    rights.&nbsp;Improve&nbsp;does
                                    not warrant that the Content will be error free, nor free of viruses, nor free
                                    from defamatory, offensive, infringing or other harmful matter. You assume the
                                    entire cost of any necessary service, repair, or correction. The Content may
                                    include inaccuracies or typographical errors that will be corrected as they are
                                    discovered at&nbsp;Improve’s sole discretion. You acknowledge that&nbsp;Improve&nbsp;has
                                    not undertaken any verification of Content featured on this Site.</span></p>

                            <p><span>4.2 By submitting a photograph or image to
                                    this Site, you grant&nbsp;Improve&nbsp;permission to use it, either in its
                                    original format or altered or cropped, on this Site in any way deemed
                                    appropriate by&nbsp;Improve.</span></p>

                            <p><span>5. Site links</span></p>

                            <p><span>5.1 This Site links to websites operated by
                                    third parties.&nbsp;Improve&nbsp;does not control these third-party websites
                                    and is not responsible for their content. The presence on this Site of a link
                                    to a website operated by a third party does not imply any endorsement
                                    by&nbsp;Improve&nbsp;of
                                    that third party or of any products or services advertised, or other
                                    information or content featured on that website. Nor does it constitute any
                                    assurance by&nbsp;Improve&nbsp;that that website has in place security measures
                                    to protect information which you may submit online.</span></p>

                            <p><span>6. Conduct of users</span></p>

                            <p><span>6.1 You acknowledge that you are solely
                                    responsible for interactions with other Users of this Site and that you are
                                    solely responsible for all materials that you publish or post to this Site or
                                    transmit to other Users of this Site</span></p>

                            <p><span>6.2 You agree that by interacting with this
                                    Site or providing materials to&nbsp;Improve&nbsp;that you are
                                    granting&nbsp;Improve&nbsp;permission
                                    to use that material on this Site</span></p>

                            <p><span>6.3 You agree not to post, distribute or
                                    reproduce in any way any copyright material, trademarks or other proprietary
                                    information without obtaining the prior consent of the owner of such
                                    proprietary rights</span></p>

                            <p><span>6.4 You will not include material on this
                                    Site, which contains offensive anatomical or sexual references, or offensive
                                    language, and you will not post any photograph or image containing nudity or
                                    personal information.&nbsp;Improve&nbsp;reserves the right, but has no
                                    obligation, to reject any text, photograph or other image that does not comply
                                    with these prohibitions</span></p>

                            <p><span>6.5 You agree not to transmit any chain
                                    letters, spam letters, or junk email to other Users, not to participate in
                                    mischievous or malicious behaviour which causes damage or may cause damage
                                    to&nbsp;Improve&nbsp;or this Site or any of the computer systems on which this
                                    Site resides. You agree not to attempt to bypass any of the security measures
                                    implemented on this Site or on any of the computer systems on which this Site
                                    resides.</span></p>

                            <p><span>7. Marketing and Publicity</span></p>

                            <p><span>7.1&nbsp;Improve&nbsp;may from time to time
                                    obtain publicity for this Site in the marketing press, internet trade press and
                                    general popular press, as well as newspapers, magazines and other publications
                                    both national and international. You agree that these publications may
                                    without&nbsp;Improve&nbsp;knowledge
                                    obtain screenshots or quotations or other publicly accessible material from
                                    this Site to be used in such publications that may feature your&nbsp;Improve&nbsp;entry,
                                    profile and/or photograph</span></p>

                            <p><span>7.2 You agree to release all rights
                                    concerning such material as referenced in to&nbsp;Improve&nbsp;and agree that
                                    your entry, profile and/or photograph may be used for such
                                    purposes.&nbsp;Improve&nbsp;agrees
                                    that it will contact you for your comments in all cases where it is aware that
                                    your information is contained in any such screenshot.&nbsp;Improve&nbsp;will
                                    endeavour to do this prior to any deadline for which the screenshot may be
                                    required.</span></p>

                            <p><span>8. Disclaimer of warranty and limitation of
                                    liability</span></p>

                            <p><span>8.1 Under no circumstances shall&nbsp;Improve,
                                    nor affiliates, staff, agents or suppliers, be liable for any damages,
                                    including without limitation, direct, indirect, incidental, special, punitive,
                                    consequential, or other damages (including without limitation lost profits,
                                    lost revenues, or similar economic loss), whether in contract, tort, or otherwise,
                                    arising out of the use or inability to use the Content available in this Site
                                    or any linked site, even if&nbsp;Improve&nbsp;is advised of the possibility
                                    thereof, nor for any claim by a third party</span></p>

                            <p><span>8.2&nbsp;Improve&nbsp;hereby expressly
                                    disclaims any and all warranties, including without limitation, any warranties
                                    to the availability, accuracy, or information, products or services, and any
                                    warranties of satisfactory quality or fitness for a particular purpose</span></p>

                            <p><span>8.3&nbsp;Improve&nbsp;shall in no event be
                                    liable for any failure of performance, error, omission, interruption, deletion,
                                    defect, delay in operation or transmission, communications line failure, theft
                                    or destruction or unauthorized access to, alteration of, or use of records for
                                    any cause of action.</span></p>

                            <p><span>9. Indemnity</span></p>

                            <p><span>9.1 You agree to defend, fully indemnify
                                    and keep fully indemnified at all times, and hold harmless&nbsp;Improve, its
                                    officers, directors, employees, agents and third parties, for any losses,
                                    costs, liabilities, damages and expenses (including reasonable fees) relating
                                    to or arising out of your use of this Site including, without limitation, any
                                    infringement of any third party’s rights (including without limitation
                                    intellectual property rights and rights of privacy and publicity) and any
                                    unlawful material you submit to this Site (including without limitation
                                    material which is or could be deemed defamatory, obscene, offensive,
                                    inaccurate, blasphemous, threatening or illegal), including any breach by you
                                    of the terms of this agreement.</span></p>

                            <p><span>10. Severability</span></p>

                            <p><span>10.1 In the event any term or condition of
                                    this agreement is prohibited by local or other law, this agreement shall be
                                    construed in such a manner as to give force and effect to every lawful
                                    provision.</span></p>

                            <p><span>11. Notice</span></p>

                            <p><span>11.1 The terms of use shall be governed in
                                    accordance with the laws of England. The terms and conditions of this agreement
                                    are subject to change by&nbsp;Improve&nbsp;at any time on a prospective basis
                                    upon notice to Users. Any User’s use of this Site following such notice shall
                                    indicate the User’s acceptance of the new terms and conditions may provide
                                    notice to Users by email or by a general posting on this Site.</span></p>

                            <p><span>12. Personal data protection</span></p>

                            <p><span>12.1&nbsp;Improve&nbsp;will store all data
                                    including your personal information submitted to this Site. If you do not want
                                    your personal information to be stored by&nbsp;Improve&nbsp;please disconnect
                                    from this Site now. By using this Site, you consent to the collection and use
                                    by&nbsp;Improve&nbsp;of your personal information for the purpose of
                                    effectively meeting the objectives of&nbsp;Improve. You may withdraw this consent
                                    at any time by emailing&nbsp;help@improve.online </span></p>

                            <p><span>12.2&nbsp;Improve&nbsp;may contact you via
                                    email or telephone from time to time to update you about functionality changes
                                    and new services on offer. You can opt out of these communications by
                                    emailing&nbsp;help@improve.online </span></p>

                            <p><span>12.3&nbsp;Improve&nbsp;is not responsible
                                    for privacy practices of third-party websites linked to this
                                    Site.&nbsp;Improve&nbsp;undertakes
                                    not to disclose any of your personal information to third parties without your
                                    consent.&nbsp;Improve&nbsp;follows strict security procedures in the storage of
                                    your personal information to prevent unauthorised access.</span></p>

                            <p><span>13. Copyrights and trademarks</span></p>

                            <p><span>13.1 All Content and materials on this
                                    Site, save where otherwise expressed, are subject to copyright and are
                                    protected by worldwide copyright laws and treaty provisions. No logo, graphic,
                                    text, sound or image from this website may be copied, reproduced, modified,
                                    published, uploaded, posted, transmitted, or distributed in any way,
                                    without&nbsp;Improve’s prior written permission. Except as expressly provided
                                    herein,&nbsp;Improve&nbsp;does not grant any express or implied right to you
                                    under any patents, copyrights or trademarks. Copyright Improve Productions Ltd
                                    2023. All rights reserved.&nbsp;Registered office:&nbsp;Space City, Dock, 75 Exploration Drive, Leicester, LE4 5NU.</span></p>

                            <p><i><span>Updated: March 2023</span></i></p>

                            <p><span>&nbsp;</span></p>

                        </div>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
    name: "UsagePolicy",
    metaInfo() {
        return {
                title: "Usage Policy | Improve Online",
                meta: [
                // Meta Description
                { name: "description", content: "Read Improve Online's usage policy, including terms of use, site content, user conduct, and personal data protection. Stay informed about our guidelines and responsibilities." },
                
                // Keywords
                { name: "keywords", content: "Usage Policy, Website Terms, User Conduct, Liability Disclaimer, Data Protection, Copyright, Trademarks, Third-Party Links, Improve Online" },

                // Open Graph / Facebook Tags
                { property: "og:title", content: "Usage Policy | Improve Online" },
                { property: "og:description", content: "Discover the official usage policy of Improve Online, including disclaimers, user responsibilities, copyright notices, and data protection measures." },
                { property: "og:image", content: "https://www.improve.online/static/SEO.png" },
                { property: "og:url", content: `https://www.improve.online/usage-policy` },
                
                // Twitter Card Tags
                { name: "twitter:card", content: "summary_large_image" },
                { name: "twitter:title", content: "Usage Policy | Improve Online" },
                { name: "twitter:description", content: "Understand Improve Online's terms of use, disclaimers, and data protection policies to ensure compliance while using the website." },
                { name: "twitter:image", content: "https://www.improve.online/static/SEO.png" },
                ],
                link: [
                // Canonical URL
                { rel: "canonical", href: `https://www.improve.online/usage-policy` },
                ],
        };
    },
    components: {
        LayoutBasic
    }
};
</script>
